import i18n from '@/i18n'

export default [
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import(/* webpackChunkName: "dashboard" */ '@/views/Dashboard/Dashboard.vue'),
    meta: {
      permissions: ['Mapi.MerchantAccountGroups.Read', 'Mapi.MerchantDashboardReport.Read'],
      menu: {
        index: 10,
        routeName: 'dashboard',
        activeWhen: ['dashboard'],
        title: i18n.t('label.dashboard'),
        icon: ['fal', 'tachometer-alt-fast'],
        hasSelectedContext: ['business', 'merchant']
      }
    }
  }
]
